import ErrorsGrid from '../components/Grid';
import { ErrorProvider } from '../store';

export default function ErrorsGridLayout() {
  return <ErrorProvider>
    <ErrorsGrid />
  </ErrorProvider>;
}
